import { render } from "./CrudNutritions.vue?vue&type=template&id=527cb017&scoped=true"
import script from "./CrudNutritions.vue?vue&type=script&lang=js"
export * from "./CrudNutritions.vue?vue&type=script&lang=js"

import "./CrudNutritions.vue?vue&type=style&index=0&id=527cb017&lang=css"
import "./CrudNutritions.vue?vue&type=style&index=1&id=527cb017&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527cb017"]])

export default __exports__